import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import pxToRem from '../../utils/pxToRem'
import { deviceMin } from '../../theme/breakpoints'

const StyledViewportContainer = styled.section`
  &:not(.isFullWidth) {
    padding-inline: ${pxToRem(24)};
  }

  &:not(.isFullHeight) {
    padding-block: ${pxToRem(24)};

    @media ${deviceMin.laptop} {
      padding-block: ${pxToRem(64)};
    }
  }

  ${({ isBlack, isWhite, isGrey, theme }) => {
    if (isBlack) return `background: ${theme.colors.unique.black};`;
    if (isWhite) return `background: ${theme.colors.unique.white};`;
    if (isGrey) return `background: ${theme.colors.unique.grayLight};`;
    return '';
  }}

  > * {
    margin-inline: auto;

    @media ${deviceMin.tablet} {
      max-width: ${({ theme }) => 'calc(' + theme.maxWidths.tablet + ' - ' + pxToRem(48) + ')'}
    }

    @media ${deviceMin.laptopL} {
      max-width: ${pxToRem(1200)};
    }
  }
`;

const ViewportContainer = ({
  className,
  children,
  isFullWidth,
  isFullHeight,
  isBlack,
  isGrey,
  isWhite,
}) => {
  const classes = `
    ${className} 
    ${isFullWidth ? 'isFullWidth' : ''}
    ${isFullHeight ? 'isFullHeight' : ''}
    `.trim();

  return (
    <StyledViewportContainer
      className={classes}
      isFullWidth={isFullWidth}
      isFullHeight={isFullHeight}
      isBlack={isBlack}
      isGrey={isGrey}
      isWhite={isWhite}
    >
      {children}
    </StyledViewportContainer>
  );
};

ViewportContainer.propTypes = {
  /** Enable the full width mode */
  isFullWidth: PropTypes.bool,
  isFullHeight: PropTypes.bool,
  /** Externales CSS Classes */
  className: PropTypes.string,
  /** Content container */
  children: PropTypes.node.isRequired,
};

ViewportContainer.defaultProps = {
  className: '',
  isFullWidth: false,
  isFullHeight: false,
  isBlack: false,
  isGrey: false,
  isWhite: false,
};

export default ViewportContainer;
